import Vue from 'vue';
import gsap from 'gsap';

import { ScrollTrigger } from 'gsap/ScrollTrigger';

Vue.component('slider-component', {
    props: {
        slides: {
            type: Array,
            default: () => [],
        },
    },
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            currentIndex: 1,
            maxIndex: 1,
            nextButton: null,
            prevButton: null,
            movement: null,
            activeNumber: 1,
            inProgress: false,
            autoplayInterval: null,
            scrollTrigger: null,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.maxIndex = this.slides.length;
        this.nextButton = this.$el.querySelector('.slider__controls-next');
        this.prevButton = this.$el.querySelector('.slider__controls-previous');
        this.inViewCheck();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        handlePrevious() {
            if (this.inProgress) {
                return;
            }
            this.inProgress = true;
            this.movement = 'left';
            if (this.currentIndex === 1) {
                this.currentIndex = this.maxIndex;
            } else {
                this.currentIndex -= 1;
            }
            gsap.to('.slider__indicator-current', {
                y: 50,
                ease: 'Power2.out',
                duration: 0.4,
                onComplete: () => {
                    this.activeNumber = this.currentIndex;
                    gsap.fromTo('.slider__indicator-current', { y: -50 }, {
                        y: 0,
                        ease: 'Power2.out',
                        duration: 0.4,
                    });
                },
            });
        },

        handleNext() {
            if (this.inProgress) {
                return;
            }
            this.inProgress = true;
            this.movement = 'right';
            if (this.currentIndex === this.maxIndex) {
                this.currentIndex = 1;
            } else {
                this.currentIndex += 1;
            }
            gsap.to('.slider__indicator-current', {
                y: -50,
                ease: 'Power2.out',
                duration: 0.4,
                onComplete: () => {
                    this.activeNumber = this.currentIndex;
                    gsap.fromTo('.slider__indicator-current', { y: 50 }, {
                        y: 0,
                        ease: 'Power2.out',
                        duration: 0.4,
                    });
                },
            });
        },

        beforeEnter(el) {
            const image = el.querySelector('.slider__slide-image-picture-holder');

            gsap.set(el, {
                zIndex: 3,
                opacity: 1,
            });

            gsap.set(image, {
                scale: 1.8,
                x: '-50%',
            });
        },

        enter(el, done) {
            const image = el.querySelector('.slider__slide-image-picture-holder');
            gsap.to(image, {
                scale: 1.2,
                x: 0,
                duration: 0.8,
                ease: 'Power2.inOut',
                onComplete: done,
            });

            if (this.movement === 'left') {
                gsap.fromTo(el, {
                    scale: 1.2,
                }, {
                    scale: 1,
                    duration: 0.8,
                    ease: 'Power2.inOut',
                });
            } else {
                gsap.fromTo(el, { x: '100%' }, {
                    x: 0,
                    duration: 0.8,
                    ease: 'Power2.inOut',
                });
            }
        },

        afterEnter(el) {
            gsap.set(el, {
                x: 0,
                zIndex: 3,
            });
            this.inProgress = false;
        },

        beforeLeave(el) {
            if (this.movement === 'left') {
                gsap.set(el, {
                    zIndex: 4,
                });
            } else {
                gsap.set(el, {
                    zIndex: 2,
                });
            }
        },

        leave(el, done) {
            const image = el.querySelector('.slider__slide-image-picture-holder');

            if (this.movement === 'left') {
                gsap.to(el, {
                    x: '100%',
                    duration: 0.8,
                    ease: 'Power2.inOut',
                });
                gsap.to(image, {
                    scale: 1.4,
                    x: '-50%',
                    duration: 0.8,
                    ease: 'Power2.inOut',
                    onComplete: () => {
                        gsap.set(el, {
                            x: 0,
                            zIndex: 2,
                            opacity: 0,
                        });
                        gsap.set(image, {
                            x: 0,
                        });
                    },
                });
            } else {
                gsap.to(image, {
                    scale: 1,
                    duration: 0.8,
                    ease: 'Power2.inOut',
                    onComplete: () => {
                        gsap.set(el, {
                            x: 0,
                            opacity: 0,
                        });
                        gsap.delayedCall(0.4, done);
                    },
                });
            }
        },

        afterLeave(el) {
            const image = el.querySelector('.slider__slide-image-picture-holder');

            gsap.set(image, {
                scale: 1.8,
            });
            gsap.set(el, {
                x: 0,
                zIndex: 2,
                opacity: 0,
            });
        },

        inViewCheck() {
            this.scrollTrigger = ScrollTrigger.create({
                trigger: this.$el,
                start: 'top bottom',
                end: 'bottom 50%',
                // markers: true,
                onEnter: () => {
                    this.autoplayInterval = setInterval(() => {
                        this.handleNext();
                    }, 7500);
                },
                onLeave: () => {
                    clearInterval(this.autoplayInterval);
                    this.autoplayInterval = null;
                },
                onEnterBack: () => {
                    this.autoplayInterval = setInterval(() => {
                        this.handleNext();
                    }, 7500);
                },
                onLeaveBack: () => {
                    clearInterval(this.autoplayInterval);
                    this.autoplayInterval = null;
                },
            });
        },
    },
});
